import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Attach JWT for admin routes
api.interceptors.request.use((config) => {
  try {
    const token = localStorage.getItem('adt_admin_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (e) { /* noop */ }
  return config;
});

export function setToken(token) {
  if (token) localStorage.setItem('adt_admin_token', token);
  else localStorage.removeItem('adt_admin_token');
}

export function getToken() {
  try { return localStorage.getItem('adt_admin_token'); } catch (e) { return null; }
}

export function setAdminUsername(u) {
  if (u) localStorage.setItem('adt_admin_username', u);
  else localStorage.removeItem('adt_admin_username');
}

export function getAdminUsername() {
  try { return localStorage.getItem('adt_admin_username'); } catch (e) { return null; }
}
